import { getDefaultExportFromCjs as r } from "../../_virtual/_commonjsHelpers.js";
var a = Array.isArray, s = a;
const i = /* @__PURE__ */ r(s);
export {
  i as default,
  s as i
};
//# sourceMappingURL=isArray.js.map
